<template>
  <div id="app" v-cloak>
    <div id="indiaPage" v-if="notIN">
      <page-A></page-A>
    </div>
    <div id="gpPage" v-if="isIN">
      <page-B></page-B>
    </div>
  </div>
</template>

<script>
import pageA from "@/components/pageA.vue";
import pageB from "@/components/pageB.vue";

export default {
  name: "App",
  components: {
    pageA,
    pageB,
  },
  data() {
    return {
      isIN: false,
      notIN: false,
    };
  },
  mounted() {
    this.loadInfo();
  },
  methods: {
    async loadInfo() {
      let resp = await this.$axios.get(process.env.IP_HOST + "/sf/");
      let respData = resp.data;
      if (respData.status == 0) {
        let ipInfo = respData.data;
        if (ipInfo.country_iso_code == "US") {
          this.isIN = true;
          document.title = "LasVegas Slots";
          return;
        }
        this.notIN = true;
        document.title = "Nevada Mini Map";
      } else {
        this.notIN = true;
        document.title = "Nevada Mini Map";
      }
    },
  },
  watch: {
    $route() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/App.vue